export default __webpack_public_path__ + "static/media/logo_EnerTEF_Icon.7a9e34cc.svg";